import ApiDocsPage from '../pages/dashboard/components/pages/apikeys/ApiDocsPage';

export default function ApiDocsRoute() {
  return <ApiDocsPage />;
}
